<template>
  <div class="item-base" >
    <div class="first" v-if="ImgList">
      <img :src="'http://'+item.photoUrl" alt="" v-for="(item,index) in ImgList" :key="index" >
      <div class="float-content"></div>
      <div class="float-content second" v-if="ImgList.length>5"></div>
      <div class="float-content third" v-if="ImgList.length>10" ></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "QuaImage",
    props:{
      ImgList:{},
    },
    created() {

    },
    mounted() {
      console.log(this.ImgList.length);
    },
  }
</script>

<style lang="less" scoped>
.item-base{
  .first{
    display: flex;
    flex-wrap: wrap;
    position: relative;
    justify-content: space-evenly;
  }
  img{
    width: 14vw;
    height: 250px;
    margin-bottom: 60px;
    object-fit: cover;
    border-radius: 2px;
    z-index: 25;
  }
  padding-bottom: 40px;
  .float-content{
    width: 100%;
    height: 270px;
    background: url('../../../assets/quality/backimage.png') center center / cover no-repeat ;
    display: flex;
    z-index: 24;
    justify-content: center;
    position: absolute;
    left: 10px;
  }
  .second{
    top: 330px;
  }
  .third{
    top: 660px;
  }
}
</style>